<div class="dialog rounded-0">
  <div class="dialog-header border-0 m-auto">
    <button type="button" class="btn btn-sm close" (click)="onCancel()">
      <span><i class="icon icon-btn-close" aria-hidden="true"></i></span>
    </button>
  </div>

  <div class="dialog-content border-0 m-auto">
    <div class="text-center mb-1 dialog-text title" *ngIf="!!title">{{title}}</div>
    <div class="text-center dialog-text message" *ngIf="!!message">{{message}}</div>
    <div class="text-center controls">
      <button type="button" *ngIf="!hideCancel" class="btn border-0 gray mr-2" (click)="onCancel()">
        <span>CANCEL</span>
      </button>
      <button type="button" class="btn border-0 blue" (click)="onSubmit()">
        <span>{{buttonText | uppercase}}</span>
      </button>
    </div>
  </div>
</div>